// 前端 HTTP 请求客户端：封装 axios、接口域名、鉴权头和通用错误处理。
import axios from "axios";
import router from "@/router";
import { Message } from "element-ui";
import { DEFAULT_LOCALE } from '@/i18n/config'
import { I18N_KEYS } from '@/i18n/keys'
import { processErrorResponse } from './apiErrorMessages';
import i18n from '@/i18n';
import { clearTermsAgreementStatus } from '@/utils/termsAgreementStorage';
export let baseURL1 = process.env.VUE_APP_BASE_URL_1
// 如果环境变量未设置，使用默认后端地址
export let baseURL2 = process.env.VUE_APP_BASE_URL_2 || 'https://sumaidesign.ai/aistructure-backend'

let isHandlingAuthExpired = false
let lastAuthExpiredAt = 0

export function clearAuthStorage() {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("authority");
    localStorage.removeItem("email");
    localStorage.removeItem("userType");
    localStorage.removeItem("availableItem");
    localStorage.removeItem("userId");
    localStorage.removeItem("read_msg");
    localStorage.removeItem("all");
    localStorage.removeItem("read");
    clearTermsAgreementStatus();
    sessionStorage.removeItem("loginStatus");
    sessionStorage.removeItem("token");
}

function redirectToLogin() {
    const currentPath = router?.currentRoute?.fullPath;
    const isOnLogin =
        router?.currentRoute?.path === "/login" ||
        (typeof currentPath === "string" && currentPath.startsWith("/login"));

    if (isOnLogin) return;

    router
        .replace({
            path: "/login",
            query: currentPath ? { redirect: currentPath } : undefined,
        })
        .catch(() => {});
}

function getAuthExpiredMessage() {
    try {
        return String(i18n.t(I18N_KEYS.AUTH.AUTH_EXPIRED_RELOGIN));
    } catch (e) {
        return "用户授权已过期，请重新登录！";
    }
}

function handleAuthExpired(message) {
    const now = Date.now();
    // 防止并发请求触发多次弹窗/跳转
    if (isHandlingAuthExpired && now - lastAuthExpiredAt < 1500) return;

    isHandlingAuthExpired = true;
    lastAuthExpiredAt = now;

    try {
        Message.error(message || getAuthExpiredMessage());
    } catch (e) {
        // ignore
    }

    try {
        clearAuthStorage();
    } catch (e) {
        // ignore
    }

    redirectToLogin();

    // 允许后续在一段时间后再次触发（例如用户重新登录后）
    window.setTimeout(() => {
        isHandlingAuthExpired = false;
    }, 1500);
}

function isUnauthorizedByPayload(payload) {
    // Java 后端常返回 HTTP 200 + body.status=401
    return payload && typeof payload === "object" && Number(payload.status) === 401;
}


export function request(config) {
    const instance = axios.create({
        baseURL: baseURL1,//代理服务器地址
    })
    //请求拦截
    instance.interceptors.request.use(config => {
        const token = sessionStorage.getItem('token');
        // 如果有token的话，让每一个请求携带token
        if (token) {
            config.headers['Authorization'] = token //让每一个请求携带token
        }
        // 获取当前语言设置，确保使用完整的语言代码格式
        let currentLang = localStorage.getItem('lang');
        if (!currentLang) {
            // 如果没有保存的语言设置，使用默认值
            currentLang = JSON.stringify(DEFAULT_LOCALE);
            localStorage.setItem('lang', currentLang);
        }
        config.headers['language'] = JSON.parse(currentLang);
        return config
    }, err => {
        console.error(err);
    })
    //响应拦截
    instance.interceptors.response.use(response => {
        if (response.status == 401 || isUnauthorizedByPayload(response.data)) {
            handleAuthExpired();
            return response.data;
        }
        const responseData = response.data;
        
        // 处理错误响应，添加 errorCode 和 localizedMsg
        if (responseData && responseData.status !== 200) {
            const processedResponse = processErrorResponse(responseData, (key) => {
                try {
                    return i18n.t(key);
                } catch (e) {
                    console.warn('Failed to translate error message:', e);
                    return null;
                }
            });
            
            // 如果有 localizedMsg，直接替换 msg（这样组件无需修改，直接使用 res.msg 即可）
            if (processedResponse.localizedMsg) {
                processedResponse.originalMsg = processedResponse.msg;
                processedResponse.msg = processedResponse.localizedMsg;
            }
            
            // 将处理后的响应数据返回，包含 errorCode 和 localizedMsg
            return processedResponse;
        }
        
        return responseData;
    }, err => {
        if (err?.response?.status == 401 || isUnauthorizedByPayload(err?.response?.data)) {
            handleAuthExpired();
        } else {
            console.error(err);
        }
        return err?.response?.data;
    })

    return instance(config)
}

export function request2(config) {
    const instance = axios.create({
        baseURL: baseURL2,//代理服务器地址
    })
    //请求拦截
    instance.interceptors.request.use(config => {
        const token = localStorage.getItem('token');
        // 如果有token的话，让每一个请求携带token
        if (token) {
            config.headers['token'] = token
            config.headers['Authorization'] = token //让每一个请求携带token
        }
        // 同步携带当前登录用户名，兼容后端基于 username 的接口（如 /login/user-profile）
        const username = localStorage.getItem('username') || sessionStorage.getItem('username');
        if (username) {
            config.headers['username'] = username;
        }
        // 获取当前语言设置，确保使用完整的语言代码格式
        let currentLang = localStorage.getItem('lang');
        if (!currentLang) {
            // 如果没有保存的语言设置，使用默认值
            currentLang = JSON.stringify(DEFAULT_LOCALE);
            localStorage.setItem('lang', currentLang);
        }
        config.headers['language'] = JSON.parse(currentLang);
        return config
    }, err => {
        console.error(err);
    })
    //响应拦截
    instance.interceptors.response.use(response => {
        // response.data = JSON.parse(response.request.responseText);
        if (response.config && response.config.responseType === 'blob') {
            return response;
        }
        if (response.status == 401 || isUnauthorizedByPayload(response.data)) {
            handleAuthExpired();
            return response.data;
        }
        const responseData = response.data;
        
        // 处理错误响应，添加 errorCode 和 localizedMsg
        if (responseData && typeof responseData === 'object' && responseData.status != null && Number(responseData.status) !== 200) {
            const processedResponse = processErrorResponse(responseData, (key) => {
                try {
                    return i18n.t(key);
                } catch (e) {
                    console.warn('Failed to translate error message:', e);
                    return null;
                }
            });
            
            // 如果有 localizedMsg，直接替换 msg（这样组件无需修改，直接使用 res.msg 即可）
            if (processedResponse.localizedMsg) {
                processedResponse.originalMsg = processedResponse.msg;
                processedResponse.msg = processedResponse.localizedMsg;
            }
            
            // 将处理后的响应数据返回，包含 errorCode 和 localizedMsg
            return processedResponse;
        }
        
        return responseData;
    }, err => {
        if (err?.response?.status == 401 || isUnauthorizedByPayload(err?.response?.data)) {
            handleAuthExpired();
        } else {
            console.error(err);
        }
        return err?.response?.data;
    })

    return instance(config)
}
